import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import ROUTES from "./listingRoutes";
import "./SuccessPage.css";

const SuccessPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [countdown, setCountdown] = useState(5);

    const type = location.state?.type;
    const routeData = ROUTES[type];

    useEffect(() => {
        if (!type || !routeData) {
            navigate("/");
        }
    }, [type, routeData, navigate]);

    useEffect(() => {
        if (!routeData) return;

        if (countdown === 0) {
            navigate(routeData.listing);
            return;
        }

        const timer = setTimeout(() => {
            setCountdown(prev => prev - 1);
        }, 1000);

        return () => clearTimeout(timer);
    }, [countdown, routeData, navigate]);

    if (!routeData) return null;

    return (
        <div className="success-page">
            <div className="success-container">
                <div className="success-card">
                    {/* Header with Brand */}
                    <div className="success-header">
                        <div className="brand-section">
                            <div className="brand-logo">D</div>
                            <h2 className="brand-name">Draptor</h2>
                        </div>

                        <div className="success-icon-wrapper">
                            <CheckCircleFilled className="success-icon" />
                        </div>

                        <h3 className="success-title">
                            {routeData.label} Added Successfully!
                        </h3>
                        <p className="success-subtitle">
                            Your {routeData.label.toLowerCase()} has been listed on Draptor.
                        </p>
                    </div>

                    {/* Action Buttons */}
                    <div className="button-group">
                        <Button
                            type="primary"
                            onClick={() => navigate(routeData.add)}
                            className="add-again-btn"
                        >
                            Add Again
                        </Button>
                        <Button
                            onClick={() => navigate(routeData.listing)}
                            className="listings-btn"
                        >
                            Go to My Listings
                        </Button>
                    </div>

                    {/* Redirect Progress */}
                    <div className="redirect-section">
                        <div className="progress-bar">
                            <div
                                className="progress-fill"
                                style={{ width: `${(countdown / 500) * 100}%` }}
                            />
                        </div>
                        <p className="redirect-text">
                            Redirecting to your {routeData.label.toLowerCase()} listings in
                            <span className="countdown-number"> {countdown}</span> second{countdown !== 1 ? 's' : ''}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SuccessPage;